import { Form } from "antd";
import { HeaderOverview, IRenderPieChart, RenderPieChart } from "components";
import {
  ErrorDashboard,
  LoadingDashboard,
  NoDataDashboard,
  WrapperBG,
  checkData,
} from "pages/overview";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import { useGetDashboardRepairingMostCategory } from "service/dashboard/central/homecare";
import { IData } from "service/dashboard/interface";

const COLORS = [
  "#0088FE",
  "#8EC641",
  "#FFBB28",
  "#FF8042",
  "#276347",
  "#F8931D",
  "#E5E5E5",
  "#535A6E",
];

const Budgets = () => {
  const { t } = useTranslation();
  const { findDate, property } = useOverview();
  const { translationObject } = useAppLanguage();

  const budgetsDate = Form.useWatch("budgetsDate");
  const date = findDate(budgetsDate);

  const { data, isFetching, isError, error } =
    useGetDashboardRepairingMostCategory({ ...date, property });

  const findData = checkData(data);

  const getData: IData[] =
    findData?.map((e) => {
      const { title } = translationObject({ object: e, keys: ["title"] });
      return { name: title, count: e.count || 0 };
    }) || [];

  const dataPie: IRenderPieChart = {
    data: getData,
    dataKey: "count",
    dataName: "name",
    color: COLORS,
    text: t("times")
  };

  return (
    <WrapperBG className="h-[350px]">
      <LoadingDashboard loading={isFetching}>
        <HeaderOverview
          title={t("budgets-for-different-categories-of-work")}
          name="budgetsDate"
        />
        {isError ? (
          <ErrorDashboard error={error} height="250px" />
        ) : !findData || findData.length <= 0 ? (
          <NoDataDashboard height="250px" />
        ) : (
          <RenderPieChart {...dataPie} />
        )}
      </LoadingDashboard>
    </WrapperBG>
  );
};

export default Budgets;
